import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Box } from '@opendoor/bricks/core';
import Layout from '@opendoor/bricks/deprecated/UNSAFE_layout/Layout';

import { SUBSCRIPTION_PREFERENCES_ROUTE } from '../../src/routes/routes';
import ErrorPage from '../routes/ErrorPage';
import NotificationPreferences from './NotificationPreferences';

const PublicNotificationPreferences: React.FC<unknown> = () => {
  const [userId, setUserId] = useState<string>();
  const id = new URLSearchParams(window.location.search).get('id');

  useEffect(() => {
    if (id) {
      setUserId(id);
    }
    // eslint-disable-next-line
  }, []);

  if (!id && window.location.pathname === SUBSCRIPTION_PREFERENCES_ROUTE) {
    const errorEmail = 'partnerships@opendoor.com';
    return (
      <ErrorPage
        headerContent="Invalid preferences link"
        errorContent={
          <>
            <p>
              Please confirm that you are accessing this page using the link provided in an email
              from Opendoor.
            </p>
            <p>
              If you believe this is an error, email us at{' '}
              <a href={`mailto:${errorEmail}`}>{errorEmail}</a> if the problem persists.
            </p>
          </>
        }
      />
    );
  }

  const renderNotificationPreferencesWithProps = () => {
    return (
      <Box maxWidth="700px" margin="auto">
        <NotificationPreferences userId={userId} />
      </Box>
    );
  };

  return (
    <Layout headerType="HIDE_NAV" footerType="NONE">
      <Switch>
        <Redirect
          exact
          from={SUBSCRIPTION_PREFERENCES_ROUTE}
          to={{
            pathname: SUBSCRIPTION_PREFERENCES_ROUTE + '/edit',
          }}
        />
        <Route
          exact
          path={SUBSCRIPTION_PREFERENCES_ROUTE + '/edit'}
          component={renderNotificationPreferencesWithProps}
        />
      </Switch>
    </Layout>
  );
};

export default PublicNotificationPreferences;
